function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-edit"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "edit",
  clipPath: "url(#clip-edit)"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-outline",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M17.783,6.728,15.272,4.217a1.833,1.833,0,0,0-2.438-.064L4.583,12.4a1.833,1.833,0,0,0-.523,1.109l-.394,3.823a.914.914,0,0,0,.917,1h.082l3.822-.348A1.833,1.833,0,0,0,9.6,17.462l8.25-8.25A1.76,1.76,0,0,0,17.783,6.728Zm-9.46,9.423-2.75.257.247-2.75L11,8.543l2.475,2.475ZM14.667,9.79,12.21,7.333,14,5.5,16.5,8Z",
  fill: "#2e5bff"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.86aaa108.svg";
export { ForwardRef as ReactComponent };